import { IDs } from '../../helpers/IDs';

export class ZertifizierungEnergieverbraucher {

    public constructor(data: any, jahr: number) {
        this.data = data;
        this.jahr = jahr || null;
        this.getMaschinen();
    }

    private data: any;
    private eintraege: Array<any> = [];
    private jahr: number;

    public getData(): Array<any> {
        return this.eintraege;
    }

    private getMaschinen(): void {
        const maschinen: Array<any> = this.data[IDs.ENT_MASCHINEN] || [];
        let nr = this.eintraege.length;

        if (!this.jahr) {
            return;
        }

        maschinen.forEach((maschine: any) => {
            const { abwaerme, baujahr, leistung, name, tid } = maschine;
            const abwaerme_temperaturniveau = abwaerme ? abwaerme + ' °C' : null;
            const alter = baujahr ? (+new Date().getFullYear() - +baujahr) + ' Jahre' : null;
            const jahreswerte: any = this.getMaschinenJahreswerte(tid) || {};
            const { auslastungsfaktor, betriebszeit_h_tag, betriebszeit_tage_jahr } = jahreswerte;
            const kapazitaet = leistung ? leistung + ' kW' : null;
            const energie = (auslastungsfaktor && betriebszeit_h_tag && betriebszeit_tage_jahr)
                    ? ((betriebszeit_h_tag * betriebszeit_tage_jahr) * (auslastungsfaktor / 100))
                    : null;
            this.eintraege.push({
                abwaerme_temperaturniveau: abwaerme_temperaturniveau,
                alter: alter,
                anlage_teil: (name || ''),
                eingesetzte_energie_kwh_energietraeger: energie,
                genauigkeit_kalibrierung: null,
                kapazitaet: kapazitaet,
                messsystem_messart: null,
                nr: ++nr
            });
        });
    }

    private getMaschinenJahreswerte(tid: number): Array<any> {
        const jahreswerte: Array<any> = this.data[IDs.ENT_MASCHINEN_JAHRESWERTE] || [];
        const data = (jahreswerte && this.jahr && tid)
            ? jahreswerte
                .filter((item: any) => (
                    item.jahr
                    && item.maschinen_tid_orig
                    && item.maschinen_tid_orig === tid
                    && item.jahr === this.jahr
                ))
            : jahreswerte;
        return data[0] ? data[0] : {};
    }
}
